@let t = toast();
@if (t) {
  <div
    [style.--toast-duration]="t.duration + 'ms'"
    [class]="'container ' + t.type + (t.duration === 0 ? ' persist' : '')"
  >
    <div class="close" (click)="closeToast()" (keypress)="closeToast()" tabindex="0"></div>
    @if (t.type === "success") {
      <img src="icons/check.svg" i18n-alt alt="check" />
    } @else if (t.type === "error") {
      <img src="icons/error.svg" i18n-alt alt="error" />
    } @else if (t.type === "info") {
      <img src="icons/info.svg" i18n-alt alt="info" />
    }
    {{ t.message }}
  </div>
}
